/* FAQ accordion */
function toggleFaq(q){
  var item=q.closest('.faq-item');
  item.classList.toggle('open');
}

/* Scroll to category */
function scrollTocat(id){
  var el=document.getElementById(id);
  if(el) el.scrollIntoView({behavior:'smooth',block:'start'});
  // Update active state
  document.querySelectorAll('.faq-nav-item,.hero-cat').forEach(function(b){
    b.classList.remove('on');
  });
  document.querySelectorAll('[onclick="scrollTocat(\''+id+'\')"]').forEach(function(b){
    b.classList.add('on');
  });
}

/* Sidebar active on scroll */
const cats=['reemploi','entretien','karpet'];
const navItems=document.querySelectorAll('.faq-nav-item');
addEventListener('scroll',function(){
  var cur='';
  cats.forEach(function(id){
    var el=document.getElementById(id);
    if(el&&el.getBoundingClientRect().top<160) cur=id;
  });
  if(cur){
    navItems.forEach(function(b){
      b.classList.toggle('on', b.getAttribute('onclick').includes(cur));
    });
  }
},{passive:true});

/* Smooth scroll */
document.querySelectorAll('a[href^="#"]').forEach(a=>a.addEventListener('click',e=>{
  const t=document.querySelector(a.getAttribute('href'));
  if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}
}));
